// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { hideLoadingOverlay, xngLoadingOverlayStyles } from "@keller/App/Components/Common/XngLoadingOverlay";
import { menuBodyStyle } from "@keller/App/Components/Menu/DropdownMenu";
import { xBaseTheme } from "@keller/XDL/types";
import { color, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    css: css`
        ${hideLoadingOverlay}
        ${xngLoadingOverlayStyles}
        ${menuBodyStyle}
        
        body {
            &,
            & [class^="PageStyle"] {
                @media print {
                    background-color: ${color("common.white")};
                    padding-bottom: 0;
                }
            }
        }

        // Fix unhandledErrorModal page style
        div[data-test-selector="unhandledErrorModal"] > [class^="PageStyle"] {
            padding: 0 !important;
            background-color: transparent !important;
        }

        .wrap-text-image {
            padding: 0 0 10px 0;
            ${xScreen("gt", "sm")} {
                float: left;
                padding: 0 10px 10px 0;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
